<div class="row">
    <div class="col-sm-12">
        <div class="chat-wrapper">
            <div class="chat-content">
                <div class="card mb-0">
                    <div class="card-header p-3">
                        <div class="d-flex align-items-center">

                            <ul class="list-inline me-auto mb-0">
                                <li class="list-inline-item">
                                    <div class="d-flex align-items-center">
                                        <div class="avtar avtar-s bg-light-primary">
                                            <span class="pc-micon"><svg class="pc-icon">
                                                    <use xlink:href="#custom-notification-status"></use>
                                                </svg></span>
                                        </div>
                                        <div class="flex-grow-1 mx-3 d-none d-sm-inline-block">
                                            <h4 class="mb-0 text-primary">{{activeTerm}}</h4>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                            <ul class="list-inline ms-auto mb-0">
                                <li class="list-inline-item">
                                    <a href="#" class="d-xxl-none avtar avtar-s btn-link-secondary"
                                        data-bs-toggle="offcanvas" data-bs-target="#offcanvas_User_info1"><i
                                            class="ti ti-info-circle f-18"></i>
                                    </a><a href="#" class="d-none d-xxl-inline-flex avtar avtar-s btn-link-secondary"
                                        data-bs-toggle="collapse" data-bs-target="#chat-user_info"
                                        aria-expanded="true"><i class="ti ti-info-circle f-18"></i></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="card-body">
                        @switch (activeTerm)
                        {
                        @case ("Market Benchmarks")
                        {
                        <app-market-benchmarks></app-market-benchmarks>
                        }
                        @case ("Terminal Handling Charges")
                        {
                        <app-terminal-handling-charges></app-terminal-handling-charges>
                        }
                        @case ("Geo-Hierarchy Methodology")
                        {
                        <app-geo-hierarchy-methodology></app-geo-hierarchy-methodology>
                        }
                        @case ("Ocean Rate Methodology")
                        {
                        <app-ocean-rate-methodology></app-ocean-rate-methodology>
                        }
                        @case ("Contract Length")
                        {
                        <app-contract-length></app-contract-length>
                        }
                        @case ("Market Metrics")
                        {
                        <app-market-metrics></app-market-metrics>
                        }
                        @case ("Contracted Within")
                        {
                        <app-contracted-within></app-contracted-within>
                        }
                        @case ("Container Types")
                        {
                        <app-container-types></app-container-types>
                        }
                        @case ("Future Rates")
                        {
                        <app-future-rates></app-future-rates>
                        }
                        @case ("Coverage")
                        {
                        <app-coverage></app-coverage>
                        }
                        @case ("Contract Validity")
                        {
                        <app-contract-validity></app-contract-validity>
                        }
                        @default
                        {
                        <app-market-benchmarks></app-market-benchmarks>
                        }
                        }
                    </div>
                </div>
            </div>

            <!-- <div *ngFor="let term of filteredTerminology">
                <h4>{{ term.term }}</h4>
                <p>{{ term.definition }}</p>
            </div> -->

            <div class="offcanvas-xxl offcanvas-end chat-offcanvas" tabindex="-1" id="offcanvas_User_info1">
                <div class="offcanvas-header">
                    <button class="btn-close" data-bs-dismiss="offcanvas" data-bs-target="#offcanvas_User_info1"
                        aria-label="Close"></button>
                </div>
                <div class="offcanvas-body p-0">
                    <div id="chat-user_info" class="collapse-horizontal collapse show">
                        <div class="chat-user_info">
                            <div class="card">
                                <div class="text-center card-body pb-3 border-bottom">
                                    <h5 class="text-start">Concepts & Terminology</h5>
                                    <div class="position-absolute end-0 top-0 p-3 d-none d-xxl-inline-flex"><a href="#"
                                            class="avtar avtar-xs btn-link-danger btn-pc-default"
                                            data-bs-toggle="collapse" data-bs-target="#chat-user_info"
                                            aria-expanded="true"><i class="ti ti-x f-16"></i></a></div>
                                </div>
                                <div>
                                    <div class="list-group list-group-flush">
                                        <a (click)="makeActive('Market Benchmarks')" href="javascript:void(0)"
                                            class="list-group-item list-group-item-action p-3">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 mx-2">
                                                    <h6 class="mb-0 text-primary">Market Benchmarks</h6>
                                                </div>
                                            </div>
                                        </a>
                                        <a (click)="makeActive('Terminal Handling Charges')" href="javascript:void(0)"
                                            class="list-group-item list-group-item-action p-3">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 mx-2">
                                                    <h6 class="mb-0 text-primary">THC (Terminal Handling Charges)</h6>
                                                </div>
                                            </div>
                                        </a>
                                        <a (click)="makeActive('Geo-Hierarchy Methodology')" href="javascript:void(0)"
                                            class="list-group-item list-group-item-action p-3">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 mx-2">
                                                    <h6 class="mb-0 text-primary">Geo-Hierarchy Methodology</h6>
                                                </div>
                                            </div>
                                        </a>
                                        <a (click)="makeActive('Ocean Rate Methodology')" href="javascript:void(0)"
                                            class="list-group-item list-group-item-action p-3">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 mx-2">
                                                    <h6 class="mb-0 text-primary">Ocean Rate Methodology
                                                    </h6>
                                                </div>
                                            </div>
                                        </a>
                                        <a (click)="makeActive('Contract Length')" href="javascript:void(0)"
                                            class="list-group-item list-group-item-action p-3">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 mx-2">
                                                    <h6 class="mb-0 text-primary">Contract Length</h6>
                                                </div>
                                            </div>
                                        </a>
                                        <a (click)="makeActive('Market Metrics')" href="javascript:void(0)"
                                            class="list-group-item list-group-item-action p-3">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 mx-2">
                                                    <h6 class="mb-0 text-primary">Market Metrics</h6>
                                                </div>
                                            </div>
                                        </a>
                                        <a (click)="makeActive('Contracted Within')" href="javascript:void(0)"
                                            class="list-group-item list-group-item-action p-3">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 mx-2">
                                                    <h6 class="mb-0 text-primary">Contracted Within</h6>
                                                </div>
                                            </div>
                                        </a>
                                        <a (click)="makeActive('Container Types')" href="javascript:void(0)"
                                            class="list-group-item list-group-item-action p-3">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 mx-2">
                                                    <h6 class="mb-0 text-primary">Container Types</h6>
                                                </div>
                                            </div>
                                        </a>
                                        <a (click)="makeActive('Future Rates')" href="javascript:void(0)"
                                            class="list-group-item list-group-item-action p-3">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 mx-2">
                                                    <h6 class="mb-0 text-primary">Future Rates</h6>
                                                </div>
                                            </div>
                                        </a>
                                        <a (click)="makeActive('Coverage')" href="javascript:void(0)"
                                            class="list-group-item list-group-item-action p-3">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 mx-2">
                                                    <h6 class="mb-0 text-primary">Coverage</h6>
                                                </div>
                                            </div>
                                        </a>
                                        <a (click)="makeActive('Contract Validity')" href="javascript:void(0)"
                                            class="list-group-item list-group-item-action p-3">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 mx-2">
                                                    <h6 class="mb-0 text-primary">Contract Validity</h6>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>